import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importData: {
		id: 'project-create-importer-upload-flow.mapping-screen.fields-dropdown.import-data',
		defaultMessage: 'Columns:',
		description: 'Heading for dropdown menu to select which columns to import',
	},
	includedColumns: {
		id: 'project-create-importer-upload-flow.mapping-screen.fields-dropdown.included-columns',
		defaultMessage: '{count, plural, one {# included} other {# included}}',
		description: 'Text for dropdown menu trigger when n fields are included in the import',
	},
	ignoredColumns: {
		id: 'project-create-importer-upload-flow.mapping-screen.fields-dropdown.ignored-columns',
		defaultMessage: '{count, plural, one {# excluded} other {# excluded}}',
		description: 'Text for dropdown menu trigger when n fields are ignored in the import',
	},
	allColumns: {
		id: 'project-create-importer-upload-flow.mapping-screen.fields-dropdown.all-columns',
		defaultMessage: 'All columns',
		description: 'Text for dropdown menu trigger when all columns are selected for import',
	},
});
